import React from 'react'
import { RichText } from './helpers/react'
import SmartContainer from './helpers/entry/smart-container2'
import { UswInfoOutline } from '@uswitch/spark-icons/usw'
import richTextStyles from './helpers/rich-text-styles'

const RichTextBlock = ({ styling, ...props }) => {
  const variant = pickVariant('elements', 'rich-text-block', props.variant)
  styling = {
    ...richTextStyles,
    ...styling,
  }
  return (
    <SmartContainer parentContentType={props.parentContentType} variant={variant} styling={styling}>
      <If condition={props?.variant === 'disclaimer'}>
        <UswInfoOutline size={40} />
      </If>
      <RichText {...props} />
    </SmartContainer>
  )
}

const pickVariant = (type, component, variant) => {
  const vari = variant === undefined || variant === 'base' ? 'base' : `variants.${variant}`

  return `${type}.${component}.${vari}`
}

export default RichTextBlock
